// Authentication types for the application

export interface LoginCredentials {
  email: string;
  password: string;
  rememberMe?: boolean;
}

export interface LoginResponse {
  date: string | null;
  email: string | null;
  employeeId: string | null;
  employeeName: string | null;
  error: string | null;
  password: string | null;
  rememberMe: boolean | null;
  successful: boolean;
  token: string;
}

export interface UserData {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  company?: string;
  district?: string;
  customerId?: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: UserData | null;
  error: string | null;
}

export interface TokenValidationResponse {
  isValid: boolean;
  user?: UserData;
  error?: string;
}

export interface RefreshTokenResponse {
  token: string;
  expiresAt: string;
}

// Error types for authentication
export class AuthError extends Error {
  code: string;
  details?: any;

  constructor({ code, message, details }: { code: string; message: string; details?: any }) {
    super(message);
    this.name = 'AuthError';
    this.code = code;
    this.details = details;
  }
}

// Common authentication error codes
export enum AuthErrorCode {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  TOKEN_INVALID = 'TOKEN_INVALID',
  NETWORK_ERROR = 'NETWORK_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
} 